export default __webpack_public_path__ + "static/img-ef-1-e3469aead9fdae2396dc7e5211a4f5d4.png";